import React from 'react';
import { Edit, NumberInput, SimpleForm } from 'react-admin';

const BalanceSheetsEdit = () => (
  <Edit mutationMode="pessimistic">
    <SimpleForm>
      <NumberInput source="close_period" />
    </SimpleForm>
  </Edit>
);

export default BalanceSheetsEdit;
